// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2phKI","error":"Textarea_error__2wyRw","readonly":"Textarea_readonly__2hoTn","disabled":"Textarea_disabled__3dgzA"};